// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"52":"3200bedd","128":"35d034e2","189":"decf2942","200":"489d0a26","216":"2cfa9b0d","228":"1d94c5c5","432":"f9079dea","504":"66c73c3d","592":"8a8b7916","640":"b29d54cf","672":"0fc753db","752":"694a4c84","808":"a311a047"}[chunkId] + ".chunk.js";
};